import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  LineController,
} from 'chart.js';

import { Bar, Line } from 'react-chartjs-2';
import { getNewApiData,  getCumulativePercenatge, getAllPartWise} from '../../../helpers/getDashBoardData';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  LineController,
);

interface IProps {
  apiData: any;
  machineWise?:any;
}

const ParetoChart = ({ apiData, machineWise }: IProps) => {
  const data = getNewApiData(apiData).sort((a, b) => b.count - a.count);
  const labels = data.map((item: { defectName: any }) => item.defectName);
  const chartData: any = {
    labels:machineWise
    ? getAllPartWise(apiData).map((item: { PartName: any }) => item.PartName)
    :labels,
    datasets: [
      {
        label: machineWise ?'Machine No. Qty':'Breakdowns Qty.',
        data:  machineWise
        ? getAllPartWise(apiData).map(
            (item: { rejectionCount: any }) => item.rejectionCount
          )
        : data.map((item: { count: any }) => item.count),
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
      },
      {
        label: 'Cumulative %',
        data:  machineWise
        ? getAllPartWise(apiData).map(
            (item: { cummPercenatge: any }) => item.cummPercenatge
          )
        :getCumulativePercenatge(apiData),
        type: 'line',
        borderColor: '#a61e4d',
        fill: false,
        yAxisID: 'y-axis-percentage',
      },
    ],
  };

  const chartOptions: any = {
    plugins: {
      maintainAspectRatio: false,
      title: {
        display: true,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: machineWise ?'Machine No.':'Breakdowns',
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: machineWise ?'Machine No. Qty':'Breakdowns Qty.',
        },
      },
      'y-axis-percentage': {
        beginAtZero: true,
        position: 'right',
        title: {
          display: true,
          text: 'Cumulative %',
        },
        grid: {
          display: false,
        },
        max: 100,
      },
    },
  };

  return (
    <div>
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export default ParetoChart;
